<template>
  <ion-page><cyan-page-wrapper title="Elegir departamento" :burst="true" backRoute="/home" nav1="PUNTO INFO">
    <mapa-sv nextRoute="/puntoPickMpio/" :key="'mapaPuntoPickDepto'"/>
    <territory-picker nextRoute="/puntoPickMpio/" />
  </cyan-page-wrapper></ion-page>
</template>

<script lang="ts">
import CyanPageWrapper, { defineComponent, IonPage } from '@/components/CyanPageWrapper.vue'
import TerritoryPicker from '@/components/TerritoryPicker.vue';
import MapaSv from '@/components/MapaSv.vue';

export default defineComponent({
  name: "PuntoPickDepto",
  components: {
    TerritoryPicker,
    CyanPageWrapper,
    IonPage,
    MapaSv
  },
  computed: {},
  methods: {}
});
</script>
